import * as actionTypes from './actionTypes';

export const fetchContributionDashboardData = payload => ({
  type: actionTypes.dashboardDataFetchType,
  payload
});

export const fetchLazyData = payload => ({
  type: actionTypes.fetchLazyDataType,
  payload
});

export const putChartData = payload => ({
  type: actionTypes.storeChartDataType,
  payload
});

export const resetChartData = () => ({
  type: actionTypes.disableShowType
});

export const restoreData = () => ({
  type: actionTypes.resetDataGrantType
})